<template>
  <div 
    class="fullscreen-poster"
    v-if="posterInfo.start"
    :class="{
      'active': isVisible,
      'closing': isClosing
    }"
  >
    <!-- 海报图片 -->
    <div class="poster-image-container">
      <div class="LearnMore" @click="goActivityPage(posterInfo.dynamicId)">
        <i class="iconfont icon-shouzhi"></i>
        <p>{{ this.$t('posterBut.ViewButton') }}</p>
      </div>
      <img 
        :src="posterInfo.posterImage" 
        :alt="posterAltText" 
        @click="goActivityPage(posterInfo.dynamicId)"
        class="poster-image"
      >
    </div>
    
    <!-- 关闭按钮 -->
    <button 
      class="close-btn"
      @click="closePoster"
      aria-label="关闭海报"
    >
      <i class="el-icon-close"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'FullscreenPoster',
  props: {
    posterInfo: {
      type: Object,
      // 对象类型的默认值必须通过函数返回
      default() {
        return {};
        },
        required: false
    },
    posterAltText: {
      type: String,
      default: '公司大型活动宣传海报推送',
      required: false
    },
    delay: {
      type: Number,
      default: 8000,
      required: false,
      NewsData: [],
    }
  },
  data() {
    return {
      isVisible: false,    // 控制显示状态
      isClosing: false     // 控制关闭动画
    };
  },
  created() {
    this.getSPGData()
  },
  methods:{
    // 请求获取数据信息
    getSPGData() {
      const query = new this.$AV.Query("SPG");
      query.get("688aea9d9bf5cd01d7ae8f8c")
      .then((SpgData) => {
        this.SpgData = JSON.parse(SpgData._hashedJSON.SpgData)
        this.NewsData = SpgData.attributes.NewsData
        this.parentBannerItems = JSON.parse(SpgData._hashedJSON.SpgData).BannerInfo
        // console.log(SpgData.attributes.NewsData)
      })
      .catch((err) => {
        console.error(err.message)
      });
    },
    // 跳转带新闻参数信息
    goToDetail(news) {
      // 列表页跳转时
      this.$router.push({
        name: 'NewsDetail',
        params: {
          // 将对象转为JSON字符串传递
          newsData: JSON.stringify(news)
        }
      })
    },
    // 跳转带新闻id并匹配数据
    goActivityPage(id) {
      // console.log('要匹配的新闻id', id)
      // 尝试解析为URL对象来判断是否为有效链接
        // 判断id中是否包含"."
      if (id.includes('.')) {
          // 存在"."，当作链接处理
          let fullUrl;
          // 补全协议头
          if (id.startsWith('http://') || id.startsWith('https://')) {
            fullUrl = id;
          } else {
            fullUrl = `https://${id}`;
          }
          // 在新页面打开链接
          window.open(fullUrl, '_blank');
          // 关闭海报
          this.closePoster()
      } else {
        // 关闭海报
        this.closePoster()
        // 查找与id匹配的新闻对象
        // 假设NewsData是数组，且每条新闻有唯一的id属性
        const matchedNews = this.NewsData.find(news => {
          // 根据实际数据结构调整匹配字段，可能是news.id或news.newsId等
          return news.id === id
        })
        
        if (matchedNews) {
          // 找到匹配的新闻，调用goToDetail跳转
          this.goToDetail(matchedNews)
        } else {
          // 未找到匹配的新闻时的处理
          console.warn(`未找到id为${id}的新闻数据或已被删除！`)
          this.$message?.error(`未找到id为${id}的新闻数据或已被删除！`) // 若有ElementUI，可加提示
          // 可选：跳转到默认详情页或提示用户
          this.$router.push('/news/NewsDetail')
        }
      }
    },
    closePoster() {
      this.isClosing = true;
      // 等待关闭动画完成后重置状态
      setTimeout(() => {
        this.isVisible = false;
        this.isClosing = false;
      }, 800); // 与CSS过渡时间一致
    }
  },
  mounted() {
    // 页面加载后，延迟指定时间显示海报
    setTimeout(() => {
      this.isVisible = true;
    }, this.delay);
  }
};
</script>

<style scoped>
.fullscreen-poster {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: -99;
  overflow: hidden;
  pointer-events: none; /* 初始不可交互 */
  
  /* 初始状态：在视口上方，不可见 */
  opacity: 0;
  visibility: hidden;
  transform: translateY(-100%);
  
  /* 动画过渡设置 */
  transition: 
    transform 0.8s ease-out, 
    opacity 0.8s ease-out,
    visibility 0.8s ease-out;
}

/* 展开动画：从上至下滑动进入 */
.fullscreen-poster.active {
  opacity: 1;
  z-index: 9999;
  visibility: visible;
  transform: translateY(0);
  pointer-events: auto; /* 允许交互 */
}

/* 关闭动画：从下至上滑动退出 */
.fullscreen-poster.closing {
  opacity: 0;
  transform: translateY(-100%);
  pointer-events: none;
}

.poster-image-container {
  width: 100%;
  height: 100%;
  position: relative;
}

.poster-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
}

.close-btn {
  position: absolute;
  bottom: 30px;
  left: 0;
  right: 0;
  margin: auto;
  /* transform: translateX(-50%); */
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  border: 2px solid white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  pointer-events: auto;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  animation: shanshuo 2s ease-in-out infinite;
}
@keyframes shanshuo {
  0%{transform: scale(1);}
  50%{transform: scale(1.1);}
  100%{transform: scale(1);}
}

.close-btn:hover {
  background-color: rgba(255, 255, 255, 0.8);
  color: #333;
  transform: translateX(-50%) scale(1.1);
}

.icon-close::before {
  content: "×";
  font-size: 28px;
  font-weight: bold;
}
.close-btn i {
	font-size: 28px;
}
/* 响应式调整 */
@media (max-width: 768px) {
  .close-btn {
    width: 50px;
    height: 50px;
    bottom: 20px;
  }
  
  .icon-close::before {
    font-size: 24px;
  }
}

@media (max-width: 480px) {
  .close-btn {
    width: 40px;
    height: 40px;
    bottom: 15px;
  }
  
  .icon-close::before {
    font-size: 20px;
  }
}
.LearnMore {
	position: fixed;
	z-index: 2;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	margin: auto;
	width: 200px;
	height: 100px;
  color: white;
  cursor: pointer;
}
.LearnMore i{
  font-size: 66px;
  display: block;
  animation: shanshuo 2s ease-in-out infinite;
}
.LearnMore p{
  font-size: 1rem;
  color: white;
}
</style>
